import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { size } from 'lodash';
import { WorkspaceLoadingService } from '../../../shared/misc-services/workspace-loading.service';
import { getShapesFromShapeInfo } from '../../h3ml/state/task-workspace-state.utils';
import { TaskWorkspaceStore } from '../../h3ml/state/task-workspace-store';
import { submitTaskIcon } from '../../shared/icons/submit-task-icon';
import { StopWorkService } from '../stop-work-button/stop-work.service';
import { SubmitTaskButtonService } from '../submit-task-button/submit-task-button.service';

export const SUBMISSION_IN_PROGRESS_TEXT = 'Task submission in progress...';
export const STOP_WORK_IN_PROGRESS_TEXT = 'Stopping work...';

@Component({
  selector: 'h3-submit-task-dialog',
  templateUrl: './submit-task-dialog.component.html',
  styleUrl: './submit-task-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SubmitTaskDialogComponent {
  private readonly store = inject(TaskWorkspaceStore);
  private readonly submitTaskButtonService = inject(SubmitTaskButtonService);
  private readonly stopWorkService = inject(StopWorkService);
  private readonly workspaceLoadingService = inject(WorkspaceLoadingService);
  private readonly matDialogRef = inject(MatDialogRef);

  submitTaskIcon = submitTaskIcon;
  objectCount = size(this.store.state().objects);
  shapeCount = getShapesFromShapeInfo(this.store.state().outputAnnotationInfo)
    .length;
  isLoading$ = this.workspaceLoadingService.isLoading$;
  progressText = signal('');

  async submitAndStopWork() {
    this.matDialogRef.disableClose = true;
    this.progressText.set(SUBMISSION_IN_PROGRESS_TEXT);
    let canStopWork = false;
    try {
      canStopWork =
        (await this.submitTaskButtonService.submit({
          loadNextTask: false,
          resumeTimerOnError: false,
        })) === 'success';
    } catch (e) {
      this.workspaceLoadingService.isLoading$.next(false);
      this.matDialogRef.disableClose = false;
      throw e;
    }
    this.progressText.set(STOP_WORK_IN_PROGRESS_TEXT);
    canStopWork && this.stopWorkService.stopWork('submit');
  }

  submitAndLoadNext() {
    this.matDialogRef.disableClose = true;
    this.progressText.set(SUBMISSION_IN_PROGRESS_TEXT);
    return this.submitTaskButtonService.submit({ resumeTimerOnError: false });
  }
}
